import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from '../../components/Copyright/Copyright';
import { 
  signIn,
  signInWithProvider,
  getUser,
} from '../../api/usersAPI';
import CustomizableSnackbar from '../../components/Snackbar/Snackbar';
import { getErrorMessage } from '../../tools/messages';
import {
  Facebook,
  Twitter,
  GitHub,
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/featured/?mountains)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn({ ...props }) {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarVariant, setSnackbarVariant] = useState('warning');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSignUp = () => {
    props.history.push('/signup');
  }
  const handleForgotPassword = () => {
    props.history.push('/forgot');
  }
  const handleSnackbarClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsSnackbarOpen(false);
  };
  const handleProviderSignIn = async (provider) => {
    try {
      const userCredential = await signInWithProvider(provider);
      const { email } = userCredential.user;
      const user = await getUser();
      const {
        isPending,
        isAccepted
      } = user;
      if (!user) {
        props.history.push({
          pathname: '/provider/signup',
          state: { user: { email, id: user.id }}
        });
      } else if (isAccepted) {
        props.history.push('/directory');
      } else if (isPending) {
        props.history.push('/pending');
      } else if (!isAccepted) {
        props.history.push('/rejected');
      }
    } catch (e) {
      const { code } = e;
      const message = getErrorMessage(code);
      setSnackbarVariant('error');
      setSnackbarMessage(message);
      setIsSnackbarOpen(true);
    }
  }
  const handleSignIn = async () => {
    if (!email.length || !password.length) {
      return;
    }
    try {
      await signIn(email.trim(), password);
      props.history.push('/directory');
    } catch (e) {
      const { code } = e;
      const message = getErrorMessage(code);
      setSnackbarVariant('error');
      setSnackbarMessage(message);
      setIsSnackbarOpen(true);
    }
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSignIn();
    }
  }
  return (
    <Grid container component="main" className={classes.root}>
      <CustomizableSnackbar
        open={isSnackbarOpen}
        handleClose={handleSnackbarClose}
        variant={snackbarVariant}
        message={snackbarMessage}
      />
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              value={email}
              autoComplete="email"
              onChange={(event) => setEmail(event.target.value)}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onKeyPress={handleKeyDown}
              onChange={(event) => setPassword(event.target.value)}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleSignIn}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link onClick={handleForgotPassword} variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link onClick={handleSignUp} variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
            <br />
              {"Or sign in with one of the following providers"}
            <br />
            <br />
            <Grid container>
              <Grid item xs>
              <ButtonGroup color="primary" aria-label="outlined primary button group">
                <Button onClick={() => handleProviderSignIn('google') }>
                  {"Google"}
                </Button>
                <Button onClick={() => handleProviderSignIn('facebook') }>
                  <Facebook />
                </Button>
                <Button onClick={() => handleProviderSignIn('twitter') }>
                  <Twitter />
                </Button>
                <Button onClick={() => handleProviderSignIn('github') }>
                  <GitHub />
                </Button>
              </ButtonGroup>
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
